import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ShoppingBag } from 'lucide-react';
import { useCartStore } from '../../store/cart';
import toast from 'react-hot-toast';
import styles from './ProductCard.module.css';

interface Props {
  product: Record<string, unknown>;
}

export default function ProductCard({ product }: Props) {
  const { t } = useTranslation();
  const addItem = useCartStore(s => s.addItem);

  const handleAdd = (e: React.MouseEvent) => {
    e.preventDefault();
    const stockCount = (product.inventory as { stockCount?: number })?.stockCount ?? (product.stockCount as number) ?? 0;
    if (!stockCount) return toast.error('Out of stock');
    addItem({
      productId: product.id as string,
      name: product.name as string,
      price: product.price as number,
      imageUrl: ((product.images as string[]) || [])[0] || '',
      stockCount,
    });
    toast.success('Added to cart!');
  };

  const inStock = ((product.inventory as { stockCount?: number })?.stockCount ?? (product.stockCount as number) ?? 0) > 0;

  return (
    <Link to={`/products/${product.id}`} className={styles.card}>
      <div className={styles.imageWrap}>
        {(product.images as string[])?.[0]
          ? <img src={(product.images as string[])[0]} alt={product.name as string} className={styles.image} />
          : <div className={styles.imagePlaceholder} />
        }
        {!inStock && <span className={styles.outBadge}>{t('product.out_of_stock')}</span>}
      </div>
      <div className={styles.info}>
        <h3 className={styles.name}>{product.name as string}</h3>
        {product.fabric ? <span className={styles.fabric}>{product.fabric as string}</span> : null}
        <div className={styles.footer}>
          <span className={styles.price}>₹{(product.price as number).toLocaleString('en-IN')}</span>
          <button
            className={styles.addBtn}
            onClick={handleAdd}
            disabled={!inStock}
            title={t('product.add_to_cart')}
          >
            <ShoppingBag size={16} />
          </button>
        </div>
      </div>
    </Link>
  );
}
